import { render } from "./question.vue?vue&type=template&id=2b83235d&lang=pug"
import script from "./question.vue?vue&type=script&setup=true&lang=js"
export * from "./question.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__